import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import AddLineIcon from 'remixicon-react/AddLineIcon';
// import ProjectSmallBox from './ProjectSmallBox';
// import ArrowDownSLineIcon from 'remixicon-react/ArrowDownSLineIcon';

const $ProjectsCardWrapper = styled(Paper, { label: 'ProjectsCardWrapper' })(({ theme }) => ({
  width: '100%',
  background: theme.palette.custom.white,
  padding: 24,
  borderRadius: 8,
  boxShadow: `0 4px 24px rgba(0, 0, 0, 0.04)`,
  position: 'relative',
  marginBottom: 24,
}));

const $CardTitle = styled(Typography, { label: 'CardTitle' })(({ theme }) => ({
  fontWeight: 700,
  lineHeight: '24px',
  letterSpacing: '0.25px',
  color: theme.palette.secondary.dark,
  display: 'flex',
  '& > span': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.secondary.dark,
    minWidth: 32,
    paddingLeft: 8,
    paddingRight: 8,
    height: 32,
    marginTop: -2,
    background: theme.palette.custom.inputBackground,
    borderRadius: 27,
    marginLeft: 12,
    fontSize: 15,
  },
}));

const $AddIcon = styled(IconButton, { label: 'AddIcon' })(({ theme }) => ({
  color: theme.palette.custom.lightBlack,
  position: 'absolute',
  right: 14,
  top: 18,
}));

const $ProjectsList = styled(Box, { label: 'ProjectsList' })(({ theme }) => ({
  '& > div:last-child': {
    borderBottom: 0,
  },
}));
//
// const $SeeMore = styled(Box, { label: 'SeeMore' })(({ theme }) => ({
//   display: 'flex',
//   alignItems: 'center',
//   justifyContent: 'center',
//   color: '#000000',
//   cursor: 'pointer',
//   marginTop: 12,
//   '& > .MuiTypography-body1': {
//     fontSize: 14,
//     fontWeight: 700,
//     color: '#000000',
//     marginTop: -2,
//     lineHeight: '19px',
//     borderBottom: `1px solid #000`,
//   },
//   '& > svg': {
//     marginLeft: 4,
//   }
// }));

const ProjectsCard = () => {
  return (
    <$ProjectsCardWrapper>
      <Box display="flex" justifyContent="space-between">
        <$CardTitle variant="h5">
          Projects
          {/*<span>3</span>*/}
        </$CardTitle>
        <$AddIcon>
          <AddLineIcon />
        </$AddIcon>
      </Box>
      <$ProjectsList>
        {/*<ProjectSmallBox />*/}
        {/*<ProjectSmallBox />*/}
      </$ProjectsList>
      {/*<$SeeMore>*/}
      {/*<Typography>See All Projects</Typography>*/}
      {/*<ArrowDownSLineIcon />*/}
      {/*</$SeeMore>*/}
    </$ProjectsCardWrapper>
  );
};

export default ProjectsCard;
